import React from "react";
import projectInfo from "../../../Information/ProjectInfo/ProjectInfo";
import FooterC from "../../Shear/FooterC/FooterC";
import MyNavbar from "../../Shear/MyNavbar/MyNavbar";
import ProjectCard from "../ProjectCard/ProjectCard";

const Project = () => {
  return (
    <main className="">
      <MyNavbar />
      <section className="container">
        <div className="d-flex flex-column align-items-center my-3">
          <h1>
            My <span style={{ color: "#01DF01" }}>Projects</span>
          </h1>
          <div className="underLine"></div>
        </div>
        <div className="my-5">
          {projectInfo.map((project) => (
            <ProjectCard key={project.id} project={project}></ProjectCard>
          ))}
        </div>
      </section>
      <FooterC />
    </main>
  );
};

export default Project;
